import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { FavoritesStore } from '../../favorites.store';
import { FavoriteItemComponent } from '../favorite-item/favorite-item.component';

@Component({
    selector: 'app-favorite-list',
    imports: [TranslatePipe, FavoriteItemComponent],
    templateUrl: './favorite-list.component.html',
    styleUrl: './favorite-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteListComponent {
    private readonly favorites = inject(FavoritesStore);
    protected readonly vm = computed(() => ({
        favoriteSites: this.favorites.favoriteSites(),
        loading: this.favorites.loading(),
    }));
    protected readonly editMode = signal(false);
    protected readonly skeletonRows = [0, 1, 2];

    constructor() {
        // Each arrival on the dashboard refreshes the favorites; the first one is already loading them.
        this.favorites.reload();
        effect(() => {
            if (this.vm().favoriteSites.length === 0) {
                this.editMode.set(false);
            }
        });
    }
}
